import { FILTER } from '@fiverr-private/listing_lib';
import { ActiveFilters } from '../../business_listings/BusinessPageLayout/Types';
import { CUSTOM_BUDGET_VALUE } from '../floating_topbar/menus/content/budget/constants';

export const isBudgetActive = (filterValues: ActiveFilters = {}): boolean => {
    const gigPriceRange = filterValues[FILTER.GIG_PRICE_RANGE.ID];
    const [min, max] = Array.isArray(gigPriceRange) ? gigPriceRange : [];
    const priceBuckets = filterValues[FILTER.PRICE_BUCKETS.ID];

    return !!(min || max || (priceBuckets && priceBuckets !== CUSTOM_BUDGET_VALUE));
};
